import React from "react";

export class WebLegend extends React.Component {
	
	constructor(props) {
        super(props);
        this.state = {
			
		}
	}
	
	render() {
		return (
			<div className="webLegendView">
				<div className="container">
					<ul className="list-group">
						<li className="list-group-item">
							<span className="border legend-test m-2">-</span>
							(White Background)
							Tracked User
						</li>
						<li className="list-group-item">
							<span className="border legend-test">-</span>
							(Red Background)
							Untracked User
						</li>
						<li className="list-group-item">
							(Red Arrow)
							Low Overall Sentiment
						</li>
						<li className="list-group-item">
							(Green Arrow)
							High Overall Sentiment
						</li>
						<li className="list-group-item">
							(Thin Arrow)
							Low Email Amount
						</li>
						<li className="list-group-item">
							(Thick Arrow)
							High Email Amount
						</li>
					</ul>
				</div>
			</div>
		)
	}
}